<template>
    <div class="comfirm" v-if="show">
        <div class="message">
            <div v-if="alertTitle" class="title">{{ alertTitle }}</div>
            <div class="content">{{ alertMsg }}</div>
            <div class="btm">
                <div @click="close()" class="comfirm_button">确定</div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            show: false
        };
    },
    props: {
        alertMsg: {
            type: String,
            required: true
        },
        alertTitle: {
            type: String,
            required: true
        },
        isAlert: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        close() {
            this.$emit('close')
        }
    },
    mounted() {
        // this.show = this.isAlert
        // console.log(1212313)
    },
    watch: {
        isAlert() {
            this.show = this.isAlert
        }
    }
};
</script>

<style lang="less" scoped>
.comfirm{
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 99;
    background:rgba(0,0,0,0.5);
    left: 0;
    top:0;
    .message{
        position: absolute;
        width: 80%;
        left: 10%;
        top: 50%;
        transform: translateY(-50%);
        background: #fff;
        border-radius: 0.16rem;
        overflow: hidden;
        font-size: 0.34rem;
        padding: 0.2rem 0.2rem 0.05rem 0.2rem;
        box-sizing: border-box;
        .title{
            line-height: 0.5rem;
            font-size: 0.3rem;
        }
        .content{
            font-size: 0.28rem;
            line-height: 0.445rem;
            padding: 0.15rem;
            box-sizing: border-box;
            text-indent:2em
        }
        .btm{
            width: 100%;
            height: 0.8rem;
            .comfirm_button{
                width: 80%;
                height: 80%;
                margin: 0.1rem auto;
                border-top: 1px solid #77DDFF;
                text-align: center;
                line-height: 0.8rem;
                font-size: 0.3rem;
                letter-spacing: 4px;
            }
        }
    }
}
</style>





// WEBPACK FOOTER //
// src/component/alert/comfirm.vue